import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-container" }

import { reactive, ref } from "vue";
import { LoginApi, userInfoApi } from "@/api/admin";
import type { FormInstance, FormRules } from "element-plus";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { useStore } from "@/store/user";
import WeChatLogin from './WeChatLogin.vue'




export default /*@__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const router = useRouter();

const formRef = ref<FormInstance>();

const userStore = useStore();

const showWeChatLogin = ref(false)

const form = reactive({
  username: "",
  password: "",
});

const rules = reactive<FormRules<typeof form>>({
  username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
  password: [
    { required: true, message: "请输入密码", trigger: "blur" },
    { min: 6, max: 15, message: "密码长度6-15位", trigger: "blur" }
  ],
});

const handleSubmit = async () => {
  if (!formRef.value) return;
  
  try {
    await formRef.value.validate();
    const res = await LoginApi(form);
    
    if (res.success) {
      localStorage.setItem("token", res.data.token);
      
      // 获取完整用户信息
      const userRes = await userInfoApi();

      const info =userRes.data.userInfo;
      if (userRes.code === 20000) {
        console.log("登录成功111",userRes)

        userStore.setUserInfo({
          username: info.username,  
          role: info.role,
          avatar: info.avatar 
        });
      }
      
      router.push("/index");
      ElMessage.success("登录成功");
    }
  } catch (error) {
    console.error('登录失败:', error);
    ElMessage.error("登录失败，请检查凭证");
  }
};

const handleWeChatLoginSuccess = (userInfo: any) => {
  // 处理微信登录成功后的逻辑
  userStore.setUserInfo({
    username: userInfo.nickname,
    role: 'user', // 根据实际情况设置角色
    avatar: userInfo.avatar
  });
  
  router.push('/index');
  ElMessage.success('微信登录成功');
}

const navigateToRegister = () => router.push("/register");


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref_key: "formRef",
      ref: formRef,
      model: form,
      rules: rules,
      class: "login-form"
    }, {
      default: _withCtx(() => [
        _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "title" }, "题海灯塔小程序管理系统", -1)),
        _createVNode(_component_el_form_item, { prop: "username" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.username) = $event)),
              size: "large",
              placeholder: "请输入用户名",
              "prefix-icon": "User"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { prop: "password" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password) = $event)),
              size: "large",
              placeholder: "请输入密码",
              "show-password": "",
              "prefix-icon": "Lock"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: handleSubmit,
              class: "submit-btn"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" 登录")
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showWeChatLogin.value = true))
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("微信扫码登录")
          ])),
          _: 1
        }),
        _createElementVNode("span", {
          class: "register-link",
          onClick: navigateToRegister
        }, "没账号？去注册")
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(WeChatLogin, {
      visible: showWeChatLogin.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((showWeChatLogin).value = $event)),
      onLoginSuccess: handleWeChatLoginSuccess
    }, null, 8, ["visible"])
  ]))
}
}

})